export default __webpack_public_path__ + "static/media/bg1.d8ad634e.jpg";